import gql from 'graphql-tag';

export default gql`
  query unions(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $season: Int
    $currency: String
  ) {
    unions(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      season: $season
      currency: $currency
    ) {
      code
      description
      isNonUnion
      preferred
    }
  }
`;
